import { css } from 'styled-components';

import { COLORS, getRgbaValue } from '../../tokens/colors';
import { rem } from '../../tokens/spacing';

/** Shared HTML body styles for template editor + preview (legacy HtmlPreviewer / .rsw-ce parity). */
export const templateRichTextContentStyles = css`
  font-size: ${rem(16)};
  line-height: 1.5;
  color: ${COLORS.Black};

  ul {
    list-style: disc;
    padding-left: 2em;
  }

  ol {
    list-style: decimal;
    padding-left: 2em;
  }

  /* Do not add global table/cell borders — email HTML uses layout tables; legacy editor/preview only style lists. */
`;

export const templateRichTextEditorRootStyles = css<{ $hasError?: boolean }>`
  min-height: ${rem(608)};

  .rsw-ce {
    flex: 1 1 auto;
    overflow: auto;
    padding: ${rem(16)};
    ${templateRichTextContentStyles}
  }

  .rsw-ce ul,
  .rsw-ce ol {
    list-style: revert;
    padding-left: 2em;
  }

  .rsw-toolbar,
  .rsw-separator {
    background: none;
    border: none;
  }

  .rsw-toolbar {
    padding: ${rem(4)};
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: ${COLORS.White};
    border-bottom: 1px solid ${COLORS.LightGray};
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${rem(4)};
    font-size: ${rem(16)};
  }

  .rsw-editor {
    border-radius: 0;
    border: 1px solid
      ${({ $hasError }) => ($hasError ? COLORS.Red : COLORS.LightGray)};
    min-height: ${rem(495)};
    max-height: ${rem(495)};
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .toolbar-custom {
    margin-top: 0 !important;
  }

  .rsw-dd {
    box-sizing: border-box;
    appearance: auto;
    min-height: ${rem(32)};
    min-width: ${rem(96)};
    padding: ${rem(4)} ${rem(28)} ${rem(4)} ${rem(10)};
    margin: 0 ${rem(2)};
    border: ${rem(1)} solid ${COLORS.LightGray};
    border-radius: ${rem(6)};
    background: ${COLORS.White};
    color: ${COLORS.Gray};
    font-family: inherit;
    font-size: ${rem(16)};
    font-weight: 500;
    line-height: ${rem(20)};
    cursor: pointer;

    &:hover {
      border-color: ${COLORS.SpanishGray};
    }

    &:focus {
      outline: none;
      border-color: ${COLORS.Purple};
      box-shadow: 0 0 0 ${rem(2)} ${getRgbaValue(COLORS.Purple, 0.2)};
    }

    option {
      font-size: ${rem(16)};
      font-weight: 400;
      color: ${COLORS.Black};
    }
  }

  .rsw-btn {
    background: ${COLORS.White};
    border: ${rem(1)} solid ${COLORS.LightGray};
    padding: ${rem(4)};
    color: ${COLORS.Gray};
    border-radius: ${rem(6)};
    font-weight: 500;
    font-size: ${rem(16)};
    line-height: ${rem(20)};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    margin: 0 ${rem(2)};
    min-width: ${rem(32)};
    width: auto;
    height: ${rem(32)};
    cursor: pointer;

    &:hover {
      border: ${rem(1)} solid ${COLORS.SpanishGray};
      box-shadow: ${rem(0)} ${rem(4)} ${rem(6)} ${getRgbaValue(COLORS.Gray100, 0.24)};
    }

    &:active {
      color: ${COLORS.Black};
      border: ${rem(1)} solid ${COLORS.SpanishGray};
    }

    &[data-active='true'] {
      background-color: ${COLORS.LightPurple};
      color: ${COLORS.Purple};
      border-color: ${COLORS.Purple};
    }
  }
`;

export const templateRichTextInsertVariablesButtonStyles = css`
  display: inline-flex;
  align-items: center;
  gap: ${rem(4)};
  height: ${rem(32)};
  padding: 0 ${rem(12)};
  margin: 0 ${rem(2)};
  background: ${COLORS.White};
  border: 1px solid ${COLORS.LightGray};
  border-radius: ${rem(6)};
  color: ${COLORS.Gray};
  font-size: ${rem(16)};
  font-weight: 500;
  line-height: ${rem(20)};
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease-in-out;

  &:hover:not(:disabled) {
    border-color: ${COLORS.SpanishGray};
    box-shadow: ${rem(0)} ${rem(4)} ${rem(6)} ${getRgbaValue(COLORS.Gray100, 0.24)};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .material-symbols-outlined {
    font-size: ${rem(20)};
    line-height: 1;
  }
`;
